import { TranscriptItem } from "../data/transcript"

export const groupItems = (items: TranscriptItem[], sceneChangeInterval = 0.3, wordsToForceBreak = 50) => {
  const outputGroupsSplitByTime = []
  let lastEndTime = 0
  let currentOutputGroup: TranscriptItem[] = []
  let shouldBreakNextPunc = false

  items.forEach((item) => {
    if (item.type === 'punctuation' && shouldBreakNextPunc) {
      // punctuation doesn't have start/end times
      shouldBreakNextPunc = false
      currentOutputGroup.push(item)
      outputGroupsSplitByTime.push(currentOutputGroup)
      currentOutputGroup = []
      return
    } else if (item.type === 'punctuation') {
      // punctuation doesn't have start/end times
      currentOutputGroup.push(item)
      return
    }

    const { start_time, end_time } = item
    const start_time_f = parseFloat(start_time)
    const end_time_f = parseFloat(end_time)

    if (start_time_f - lastEndTime >= sceneChangeInterval) {
      // scene change
      outputGroupsSplitByTime.push(currentOutputGroup)
      currentOutputGroup = [item]
    } else {
      currentOutputGroup.push(item)
    }

    if (currentOutputGroup.map((item) => item.alternatives[0].content).join(' ').length >= wordsToForceBreak) {
      shouldBreakNextPunc = true
    }

    lastEndTime = end_time_f
  })

  outputGroupsSplitByTime.push(currentOutputGroup)

  return outputGroupsSplitByTime
}

export const tsToString = (ts: number, withMs = false) => {
  const hours = Math.floor(ts / 3600)
  ts %= 3600
  const minutes = Math.floor(ts / 60)
  const seconds = Math.floor(ts % 60)

  // If you want strings with leading zeroes:
  const hoursStr = String(hours).padStart(2, "0")
  const minutesStr = String(minutes).padStart(2, "0")
  const secondsStr = String(Math.round(seconds)).padStart(2, "0")

  let msPart = ""
  if (withMs === true) {
    msPart = ((Math.round((ts % 60) * 1000) / 1000) % 1).toFixed(3).substring(1)
  }

  return hoursStr + ":" + minutesStr + ":" + secondsStr + msPart
}

export const transcriptToAnnotatedText = (items: TranscriptItem[], sceneChangeInterval = 1.0, wordsToForceBreak = 100) => {
  const itemGroups = groupItems(items, sceneChangeInterval, wordsToForceBreak)
  let outputText = ""

  itemGroups.forEach((group, idx) => {
    const pronunciationItems = group.filter(i => i.type === 'pronunciation')
    if (pronunciationItems.length < 1) {
      return null
    }

    const headItem = pronunciationItems[0]
    if (headItem.type !== 'pronunciation')
      return

    const startTs = parseFloat(headItem.start_time)

    const rest = group.map((item) => {
      let prefix = ''
      if (item !== group[0] && item.type !== 'punctuation') {
        prefix = ' '
      }
      return prefix + item.alternatives[0].content
    }).join('')

    outputText += tsToString(startTs) + "\n" + rest + "\n\n"
  })

  return outputText
}

export const transcriptToWebVTT = (items: TranscriptItem[], sceneChangeInterval = 0.3, wordsToForceBreak = 50) => {
  const itemGroups = groupItems(items, sceneChangeInterval, wordsToForceBreak)
  let outputText = "WEBVTT\n\n"

  itemGroups.forEach((group, idx) => {
    const pronunciationItems = group.filter(i => i.type === 'pronunciation')
    if (pronunciationItems.length < 1) {
      return null
    }

    const headItem = pronunciationItems[0]
    const tailItem = pronunciationItems[pronunciationItems.length - 1]

    if (headItem.type !== 'pronunciation' || tailItem.type !== 'pronunciation')
      return

    const startTs = parseFloat(headItem.start_time)
    const endTs = parseFloat(tailItem.end_time)

    const rest = group.map((item) => {
      let prefix = ''
      if (item !== group[0] && item.type !== 'punctuation') {
        prefix = ' '
      }
      return prefix + item.alternatives[0].content
    }).join('')

    const header = tsToString(startTs, true) + " --> " + tsToString(endTs, true)
    outputText += header + "\n" + rest + "\n\n"
  })

  outputText += "NOTE Generated by speech2transcript v0.1"

  return outputText
}
